import React from "react";

export const CessComp = () => {
  return (
    <>
      <div className="max-w-[1170px] relative m-auto px-5 mb-[170px]">
        <div className="mt-[50px]">
          <div className="title font-ibm-plex-sans flex">
            <span className="">
              Cess
              <div className="py-[3px] rounded bg-[#009969] w-[120px]"></div>{" "}
            </span>{" "}
            & Levies
          </div>
        </div>
        <div className="my-[20px]">
          <div className="mb-8">
            <div className="font-ibm-plex-sans font-bold text-[23px] leading-[29px] mb-3">
              Zakat
            </div>
            <div className="text-[22px] leading-[24px] text-[#40384F] ">
              Zakat is withheld from every Muslim who is not only a citizen of
              Pakistan but also 'sahib-i-nisab', at 2.5% of the value of the
              assets held on the first day of the month of Ramadan. Non-Muslims
              and non-resident shareholders of a company are exempt from the
              requirement to pay Zakat on dividends.
            </div>
          </div>

          <div className="my-8">
            <div className="font-ibm-plex-sans font-bold text-[23px] leading-[29px] mb-3">
              Workers Profit Participation Fund (WPPF)
            </div>
            <div className="text-[22px] leading-[24px] text-[#40384F] ">
              A levy is payable to the Trustees of WPPF at an agreed percentage
              of net profits as per accounts for the year by companies and
              associations of persons with more than 20 members (partners)
              engaged in industrial undertaking, and employing 50 persons or
              more, whose paid-up capital is Rs2.00 million or more and/or the
              fixed assets are Rs4.00 million or more.
            </div>
          </div>

          <div className="my-8">
            <div className="font-ibm-plex-sans font-bold text-[23px] leading-[29px] mb-3">
              Workers Welfare Fund (WWF)
            </div>
            <div className="text-[22px] leading-[24px] text-[#40384F] ">
              A levy is payable by companies engaged in industrial undertaking
              at an agreed percentage of the taxable income of the year where
              such income is Rs500,000 or more.
            </div>
          </div>

          <div className="my-8">
            <div className="font-ibm-plex-sans font-bold text-[23px] leading-[29px] mb-3">
              Workers Children Education Cess
            </div>
            <div className="text-[22px] leading-[24px] text-[#40384F] ">
              This is a provincial levy payable in every quarter by an
              establishment employing 20 workers or more at Rs25 per worker per
              quarter, except in case the employer has made arrangements for the
              education of children of his/her workers or cess/excise duty is
              paid under the Excise Duty on Minerals (Labour Welfare) Act, 1967.
            </div>
          </div>

          <div className="my-8">
            <div className="font-ibm-plex-sans font-bold text-[23px] leading-[29px] mb-3">
              Employees’ Social Security Contribution
            </div>
            <div className="text-[22px] leading-[24px] text-[#40384F] ">
              This is a provincial levy requiring every employer employing ten
              or more workers with wages up to Rs7,000 per month to pay Rs370
              per wage earner including Rs20 contributed by the wage earner per
              month to the Employees’ Social Security Institution while the
              workers and their family members are provided free medical
              treatment, maternity benefits and other assistance.
            </div>
          </div>

          <div className="my-8">
            <div className="font-ibm-plex-sans font-bold text-[23px] leading-[29px] mb-3">
              Employees’ Old-Age Benefits
            </div>
            <div className="text-[22px] leading-[24px] text-[#40384F] ">
              All dispatches of specified minerals from mines are subject to
              levy of a cess/duty of excise at the notified rate from one to
              five rupee per ton, meant for financing measures for promoting the
              welfare of labour employed in the mining industry.
            </div>
          </div>

          <div className="my-8">
            <div className="font-ibm-plex-sans font-bold text-[23px] leading-[29px] mb-3">
              Excise Duty on Minerals:
            </div>
            <div className="text-[22px] leading-[24px] text-[#40384F] ">
              All dispatches of specified minerals from mines are subject to
              levy of a cess/duty of excise at the notified rate from one to
              five rupee per ton, meant for financing measures for promoting the
              welfare of labour employed in the mining industry.
            </div>
          </div>
          <div className="my-8">
            <div className="font-ibm-plex-sans font-bold text-[23px] leading-[29px] mb-3">
              Surface Rent & Compensation
            </div>
            <div className="text-[22px] leading-[24px] text-[#40384F] ">
              The respective Government will ensure adequate access and freedom
              to the mineral title holder to carry out the prospecting,
              exploration, exploitation and processing activities etc. while the
              mineral title holders will provide fair surface rent and
              compensation to the landowner as prescribed under the mineral
              concession rules.
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
